import { generateHashFromVariables } from '../../../utils/caching/common/key-generator';
import { inMemoryCache } from '../../../utils/caching/in-memory';

import { type TeamsBulkRequest, type TeamsBulkResponse } from './types';

const TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';

const cache = inMemoryCache<any>();

export const generateCacheKey = (request: TeamsBulkRequest) => {
	const keyObj = {
		teamIds: request.teamIds.sort(),
	};

	return generateHashFromVariables(keyObj);
};

export const fetchTeamsBulk = async (
	request: TeamsBulkRequest,
	onError?: (error: any) => Promise<void>,
): Promise<TeamsBulkResponse> => {
	return cache.inMemoryDecorator(generateCacheKey(request), () =>
		fetch(TEAMS_BULK_REST_API_URL, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'content-type': 'application/json',
			},
			body: JSON.stringify(request),
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}

				const errorMessage = `Unable to fetch ${TEAMS_BULK_REST_API_URL}. ${response.statusText}`;
				onError?.(errorMessage);

				return Promise.reject({
					teams: [],
					failures: [
						{
							teamIds: request.teamIds,
							description: errorMessage,
							typeId: 'FETCH_ERROR',
						},
					],
				});
			})
			.catch((error) => {
				const errorMessage = `Unable to fetch ${TEAMS_BULK_REST_API_URL}. ${error.message}`;
				onError?.(errorMessage);

				return {
					teams: [],
					failures: [
						{
							teamIds: request.teamIds,
							description: errorMessage,
							typeId: 'FETCH_ERROR',
						},
					],
				};
			}),
	);
};
